import {
	LoginResponseDto,
	LoginResponseUser,
	LoginUserMatchingResponseDto,
	RedirectLoginResponseDto,
} from "@api-types/user/LoginResponseDto";
import { isTypeOf } from "@utils/common";
import { logger } from "@utils/logger/logger";

export function validateUserLoginResponse(
	response: LoginResponseDto | RedirectLoginResponseDto
) {
	if (!response) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (isTypeOf<LoginResponseDto>(response, "primary")) {
		if (!response.primary) {
			logger.logError(new Error("Response.primary is undefined/null"));
			return false;
		}
	} else if (isTypeOf<RedirectLoginResponseDto>(response, "redirectUrl")) {
		if (!response.redirectUrl) {
			logger.logError(new Error("RedirectUrl is undefined/null"));
			return false;
		}
	} else {
		logger.logError(new Error("Unknown response type"));
		return false;
	}

	return true;
}

export function validateMatchingDataResponse(response: string[]) {
	if (!response) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (!Array.isArray(response)) {
		logger.logError(new Error("Response is not an array"));
		return false;
	}

	return true;
}

export function validateUserMatchConfirmationResponse(
	response: LoginUserMatchingResponseDto
) {
	if (!response) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (!response.primary) {
		logger.logError(new Error("Response.primary is undefined/null"));
		return false;
	}

	return true;
}

export function validateUserLoginFromGigResponse(
	response: LoginResponseDto & {
		gigToken?: string | undefined;
	}
) {
	if (!response) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (!response.gigToken) {
		logger.logError(new Error("Response.gigToken is undefined/null"));
		return false;
	}

	if (typeof response.gigToken != "string") {
		logger.logError(new Error("Response.gigToken is not a string"));
		return false;
	}

	return true;
}

export function validateUserGigInitResponse(response: LoginResponseDto) {
	if (!response) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (isTypeOf<LoginResponseDto>(response, "primary")) {
		if (!response.primary) {
			logger.logError(new Error("Response.primary is undefined/null"));
			return false;
		}
	} else {
		logger.logError(new Error("Unknown response type"));
		return false;
	}

	return true;
}

export function validateAcceptGdprConsentResponse(response: boolean) {
	if (response == null) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (typeof response != "boolean") {
		logger.logError(new Error("Response is not boolean"));
		return false;
	}

	return true;
}

export function validateRefreshUserResponse(response: LoginResponseUser) {
	if (!response) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (isTypeOf<LoginResponseUser>(response, "id")) {
		if (!response.id) {
			logger.logError(new Error("Unknown response type"));
			return false;
		}
	}

	return true;
}
